import { createListenerMiddleware, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

import { setTrackingStatus, setCollection } from 'store/slices/collection';
import { ICollection } from 'types/collection';

export const collectionMiddleware = createListenerMiddleware();

const setUpEffectAction = (action: PayloadAction<ICollection>) => {
  const { _user } = action.payload;

  window.LANGUAGE = _.defaultTo(
    _.get(action, 'payload.language'),
    _.defaultTo(_.get(_user, 'languageApp'), 0)
  );
};

collectionMiddleware.startListening({
  actionCreator: setCollection,
  effect: setUpEffectAction
});

collectionMiddleware.startListening({
  actionCreator: setTrackingStatus,
  effect: (action: PayloadAction<'in' | 'out'>) => {
    window.localStorage.setItem(`tracking-${window.SITE_ID}`, `opt-${action.payload}`);
  }
});
